import styled from "@emotion/styled";
import { WalletReadyState } from "@solana/wallet-adapter-base";
import type { Wallet } from "@solana/wallet-adapter-react";
import type { MenuItemProps } from "antd";
import { Button } from "antd";
import type { FC, MouseEventHandler } from "react";
import React from "react";

import { useLanguageContext } from "../../contexts/language/language";
import { WalletIcon } from "./WalletIcon";

interface WalletMenuItemProps extends Omit<MenuItemProps, "onClick"> {
  onClick: MouseEventHandler<HTMLButtonElement>;
  wallet: Wallet;
}

export const WalletMenuItem: FC<WalletMenuItemProps> = ({ onClick, wallet }) => {
  const {
    currentLanguageData: {
      components: { walletModal },
    },
  } = useLanguageContext();

  return (
    <MenuButton
      key={wallet.adapter.name}
      size="large"
      onClick={onClick}
      icon={<WalletIcon wallet={wallet} />}
      type="ghost"
    >
      {wallet.readyState === WalletReadyState.NotDetected
        ? `${walletModal.install} ${wallet.adapter.name}`
        : wallet.adapter.name}
    </MenuButton>
  );
};

const MenuButton = styled(Button)`
  display: flex;
  align-items: center;
  margin-bottom: 8px;
  gap: 8px;
  width: 100%;
`;
